export const ATTACHMENT_CATEGORIES = [
    "documenti d'identità",
    'pei',
    'relazioni',
    'inserimento',
    'formazione',
    'salute',
    'penale',
    'tutela',
    'proseguo',
    'questura',
    'residenza',
    'CIM (centro per l\'impiego)',
    'lavoro',
];
